import { Component, OnInit } from '@angular/core';
import { JobService } from 'src/app/services/job.service';
import { ActivatedRoute } from '@angular/router';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { Utility } from 'src/app/core/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-job-image',
  templateUrl: './job-image.component.html',
  styleUrls: ['./job-image.component.scss']
})
export class JobImageComponent implements OnInit {

  constructor(private jobService: JobService, private route: ActivatedRoute, private spinner: SpinnerService,
    private toastr: ToastrService) { }
  get code() { return this._code; }
  set code(code: number) { this.loadJob(code); }

  get html() {
    return !this.code || !this.template ? '' :
      `${environment.app.apiUrl}job/image/html/${this.code}/${this.template}?bg=${this.bgUrl ? this.bgUrl : ''}`;
  }

  imageUrl: string;
  setImageUrl() {
    delete this.imageUrl;
    setTimeout(() => {
      this.imageUrl = !this.code || !this.template
        ? ''
        : `${environment.app.apiUrl}job/image/${this.code}/${this.template}?r=${Math.random()}&bg=${this.bgUrl ? this.bgUrl : ''}&r=${Math.random()}`;
    }, 100);

    if (this.bgUrl) {
      this.bgUrls = [...(new Set([this.bgUrl, ...this.bgUrls]))].filter(x => x);
      localStorage.setItem('job-image-bgUrls', JSON.stringify(this.bgUrls));
    }
  }

  get url() { return `/job/${this.job.Id}`; }
  now = new Date();

  job: any;
  bgUrl?: string;
  _code: number;
  templates: any[];
  template: string;
  bgUrls: string[] = [];

  async ngOnInit() {
    this.spinner.show('job-image-setting');
    this.bgUrls = JSON.parse(localStorage.getItem('job-image-bgUrls')) || [];
    const jobCode = this.route.snapshot.params['code'];
    this.loadJob(jobCode);
    this.templates = await this.jobService.templates();
    this.spinner.hide('job-image-setting');
  }

  async loadJob(code: number) {
    if (!code) { return; }
    this._code = code;
    this.spinner.show();
    this.job = await this.jobService.getByCode(code);
    this.spinner.hide();
  }

  copy(url: string) {
    if (Utility.setClipboard(url)) { this.toastr.success('آدرس آگهی کپی شد.'); }
  }

  clearBgUrls() {
    this.bgUrls = [];
    localStorage.setItem('job-image-bgUrls', JSON.stringify(this.bgUrls));
  }

}
